import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { ProjectConfidenceProps } from '@shared/widget-schemas';

const trendConfig = {
  up: { icon: TrendingUp, color: 'text-emerald-600', label: 'Up' },
  down: { icon: TrendingDown, color: 'text-red-600', label: 'Down' },
  stable: { icon: Minus, color: 'text-muted-foreground', label: 'Stable' },
} as const;

export function ProjectConfidenceWidget({ percentage, trend, delta }: ProjectConfidenceProps) {
  const { icon: TrendIcon, color, label } = trendConfig[trend];

  return (
    <Card className="w-full">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="text-4xl font-bold">{percentage}%</div>
        <div className="flex flex-col">
          <div className={cn('flex items-center gap-1 text-sm font-medium', color)}>
            <TrendIcon className="h-4 w-4" />
            <span>{label} {delta}%</span>
          </div>
          <span className="text-xs text-muted-foreground">Project confidence</span>
        </div>
      </CardContent>
    </Card>
  );
}
